import { render } from "./RecordHistory.vue?vue&type=template&id=0b351fa0"
import script from "./RecordHistory.vue?vue&type=script&lang=js"
export * from "./RecordHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__